import { render, staticRenderFns } from "./MaterialProcurement.vue?vue&type=template&id=1c7fe9ee&scoped=true"
import script from "./MaterialProcurement.vue?vue&type=script&lang=js"
export * from "./MaterialProcurement.vue?vue&type=script&lang=js"
import style0 from "./MaterialProcurement.vue?vue&type=style&index=0&id=1c7fe9ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7fe9ee",
  null
  
)

export default component.exports